import { ModalCreateWarehouseComponent } from './../modal-create-warehouse/modal-create-warehouse.component';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material';
import { Subject } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { RepositoryService } from '@app/api/api';

@Component({
  selector: 'meu-app-warehouse-management',
  templateUrl: './app-warehouse-management.component.html',
  styleUrls: ['./app-warehouse-management.component.scss'],
})
export class AppWarehouseManagementComponent implements OnInit {
  constructor(
    private layoutUtilsService: LayoutUtilsService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private warehouseService: RepositoryService
  ) {}
  displayedColumns: string[] = ['Index', 'Name', 'Code', 'Address', 'Actions'];
  lstAllWarehouse: any = [];
  total: any;
  pageSize = 10;
  pageIndex = 1;
  filter: any = '';

  pageSizeOptions: number[] = [5, 10, 20, 100];

  ngOnInit() {
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(500)
      )
      .subscribe((value) => {
        this.pageIndex = 1;
        this.pageSize = 10;
        this.filter = 'name|code|address@=*' + value;
        this.getAllWareHouse();
      });
    this.getAllWareHouse();
  }
  public keyUp = new Subject<KeyboardEvent>();
  getAllWareHouse() {
    this.warehouseService
      .apiRepositoriesGet(this.filter, '', this.pageIndex, this.pageSize)
      .subscribe((res) => {
        if (res.success) {
          this.lstAllWarehouse = res.data.collection;
          this.total = res.data.total;
          // this.pageIndex = res.data.pageIndex;
          // this.pageSize = res.data.pagesize;
          this.ref.detectChanges();
        } else {
          this.toastr.error(res.message);
        }
      });
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getAllWareHouse();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 1;
    this.getAllWareHouse();
  }

  openModalWarehouse(id) {
    const dialogRef = this.dialog.open(ModalCreateWarehouseComponent, {
      width: '900px',
      data: { id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result.event != undefined) {
        if (result.event) {
          if (result.type == 'create') {
            this.toastr.success('Tạo mới kho hàng thành công');
            this.getAllWareHouse();
          } else {
            this.toastr.success('Chỉnh sửa kho hàng thành công');
            this.getAllWareHouse();
          }
        } else {
          this.toastr.error(result.message);
        }
      }
    });
  }
  deleteWarehouse(ID) {
    const title = 'Xóa kho hàng';
    const description = 'Bạn có chắc chắn muốn xóa kho hàng này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.warehouseService.apiRepositoriesIdDelete(ID).subscribe((res) => {
          if (res.success) {
            this.toastr.success('Xoá kho hàng thành công');
            this.getAllWareHouse();
          } else {
            this.toastr.error(res.message, 'Thao tác xóa không thành công');
          }
        });
      }
    });
  }
}
